module.exports = __webpack_public_path__ + "fe9525567cb2d09d0d38a70c75567535.pdf";